<template>
  <div class="review">
    <div class="paper">
      <!-- <span class="total_score">{{totalScore}}分</span> -->
      <h2 class="paper_title">{{ $route.query.chapterTitle }}</h2>
      <div class="info_row">
        <span class="name">姓名:{{ userName }}</span>
        <span class="submit_time"
          >提交时间:{{ formatDate(submitTime, "YYYY.MM.DD HH:mm") }}</span
        >

        <el-table
          class="score_table"
          :data="tableData"
          border
          style="width: 70%"
        >
          <el-table-column prop="type" label="题型" align="center">
          </el-table-column>
          <el-table-column
            prop="radio"
            label="单选"
            align="center"
            v-if="radio.length > 0"
          >
          </el-table-column>
          <el-table-column
            prop="checkbox"
            label="多选"
            align="center"
            v-if="checkbox.length > 0"
          >
          </el-table-column>
          <el-table-column
            prop="boolean"
            label="判断"
            align="center"
            v-if="boolean.length > 0"
          >
          </el-table-column>
          <el-table-column prop="totalScore" label="总分" align="center">
            <template slot-scope="scope">
              <span style="color: #ff0000">{{ scope.row.totalScore }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="main">
        <div class="single" v-if="radio.length > 0">
          <div style="overflow: hidden; margin-top: 20px">
            <h3 class="type_title">
              单选题
              <span style="margin-left: 5px">{{ sum(radio) }}分</span>
            </h3>
            <p class="get_score">
              得分:<span style="color: #ff0000; margin: 0 10px">{{
                mySingleTotalScore
              }}</span
              >分
            </p>
          </div>
          <div
            class="one"
            v-for="(single, idx) in radio"
            :key="single.questionId"
          >
            <p class="stem">
              <span>{{ idx + 1 }}.</span>
              {{ single.question }}
            </p>
            <div class="options">
              <p
                class="option"
                v-for="option in single.optionList"
                :key="option.id"
              >
                <span>{{ option.tag }}.</span>
                {{ option.option }}
              </p>
            </div>
            <p class="my_answer">
              <span>我的答案：</span>
              {{ single.myAnswerList ? single.myAnswerList[0] : "" }}
            </p>
            <p class="anwser" v-if="showAnswer">
              <span>正确答案：</span>
              {{ single.answerList ? single.answerList[0] : "" }}
            </p>
          </div>
        </div>

        <div class="multiple" v-if="checkbox.length > 0">
          <div style="overflow: hidden; margin-top: 20px">
            <h3 class="type_title">
              多选题
              <span style="margin-left: 5px">{{ sum(checkbox) }}分</span>
            </h3>
            <p class="get_score">
              得分:<span style="color: #ff0000; margin: 0 10px">{{
                myMultipleTotalScore
              }}</span
              >分
            </p>
          </div>
          <div
            class="one"
            v-for="(multiple, idx) in checkbox"
            :key="multiple.questionId"
          >
            <p class="stem">
              <span>{{ idx + 1 }}.</span>
              {{ multiple.question }}
            </p>
            <div class="options">
              <p
                class="option"
                v-for="option in multiple.optionList"
                :key="option.id"
              >
                <span>{{ option.tag }}.</span>
                {{ option.option }}
              </p>
            </div>
            <p class="my_answer">
              <span>我的答案：</span>
              {{ multiple.myAnswerList ? multiple.myAnswerList.join("") : "" }}
            </p>
            <p class="anwser" v-if="showAnswer">
              <span>正确答案：</span>
              {{ multiple.answerList ? multiple.answerList.join("") : "" }}
            </p>
          </div>
        </div>

        <div class="judge" v-if="boolean.length > 0">
          <div style="overflow: hidden; margin-top: 20px">
            <h3 class="type_title">
              判断题
              <span style="margin-left: 5px">{{ sum(boolean) }}分</span>
            </h3>
            <p class="get_score">
              得分:<span style="color: #ff0000; margin: 0 10px">{{
                myJudgeTotalScore
              }}</span
              >分
            </p>
          </div>
          <div
            class="one"
            v-for="(judge, idx) in boolean"
            :key="judge.questionId"
          >
            <p class="stem">
              <span>{{ idx + 1 }}.</span>
              {{ judge.question }}
            </p>
            <div class="options">
              <p class="option">
                <span>A.</span>
                对
              </p>
              <p class="option">
                <span>B.</span>
                错
              </p>
            </div>
            <p class="my_answer">
              <span>我的答案：</span>
              {{ judge.myAnswerList ? judge.myAnswerList[0] : "" }}
            </p>
            <p class="anwser" v-if="showAnswer">
              <span>正确答案：</span>
              {{ judge.answerList ? judge.answerList[0] : "" }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/utils/index";
export default {
  name: "reviewTest",
  props: {
    info: Object,
  },
  data() {
    return {
      formatDate,
      radio: [],
      checkbox: [],
      boolean: [],
      tableData: [
        {
          type: "得分",
          radio: null,
          checkbox: null,
          boolean: null,
          totalScore: null,
        },
      ],
      showAnswer: false,
    };
  },
  created() {
    if (this.questionList) this.classify(this.questionList);
    this.tableData[0].radio = this.mySingleTotalScore;
    this.tableData[0].checkbox = this.myMultipleTotalScore;
    this.tableData[0].boolean = this.myJudgeTotalScore;
    this.tableData[0].totalScore = Number(
      (
        this.mySingleTotalScore +
        this.myMultipleTotalScore +
        this.myJudgeTotalScore
      ).toFixed(2)
    );
  },
  computed: {
    questionList() {
      return this.$store.state.test.questionList || [];
    },
    submitTime() {
      return this.$store.state.test.submitTime;
    },
    userName() {
      return this.$store.state.myInfo.name || this.$store.state.myInfo.username;
    },
    mySingleTotalScore() {
      return Number(
        this.radio
          .reduce((accumulator, currentValue) => {
            return accumulator + (currentValue.right ? currentValue.score : 0);
          }, 0)
          .toFixed(2)
      );
    },
    myMultipleTotalScore() {
      return Number(
        this.checkbox
          .reduce((accumulator, currentValue) => {
            return accumulator + (currentValue.right ? currentValue.score : 0);
          }, 0)
          .toFixed(2)
      );
    },
    myJudgeTotalScore() {
      return Number(
        this.boolean
          .reduce((accumulator, currentValue) => {
            return accumulator + (currentValue.right ? currentValue.score : 0);
          }, 0)
          .toFixed(2)
      );
    },
  },
  watch: {
    questionList(val) {
      this.classify(val);
      this.tableData[0].radio = this.mySingleTotalScore;
      this.tableData[0].checkbox = this.myMultipleTotalScore;
      this.tableData[0].boolean = this.myJudgeTotalScore;
      this.tableData[0].totalScore = Number(
        (
          this.mySingleTotalScore +
          this.myMultipleTotalScore +
          this.myJudgeTotalScore
        ).toFixed(2)
      );
    },
    info(val) {
      this.showAnswer = val.lookTestAnswer == "OPEN";
    },
  },
  methods: {
    // 题目分类
    classify(arr) {
      this.radio = [];
      this.checkbox = [];
      this.boolean = [];
      arr.forEach((item) => {
        switch (item.type) {
          case "RADIO":
            if (this.isInArray(this.radio, item)) return;
            this.radio.push(item);
            break;
          case "CHECKBOX":
            if (this.isInArray(this.checkbox, item)) return;
            if (item.myAnswerList) item.myAnswerList.sort();
            this.checkbox.push(item);
            break;
          case "BOOLEAN":
            if (this.isInArray(this.boolean, item)) return;
            this.boolean.push(item);
            break;
        }
      });
    },
    // 是否存在
    isInArray(arr, item) {
      return arr.some((e) => e.questionId === item.questionId);
    },
    // 计算总分
    sum(arr) {
      return Number(
        arr
          .reduce(function (prev, curr) {
            return curr.score + prev;
          }, 0)
          .toFixed(2)
      );
    },
  },
};
</script>

<style lang="less" scoped>
.review {
  height: 100%;
  .paper {
    position: relative;
    margin: 15px auto;
    padding: 40px;
    width: 915px;
    height: 95%;
    overflow: auto;
    background-image: url("../../assets/images/paper_bg.png");
    background-size: cover;
    background-repeat: no-repeat;

    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    // .total_score {
    //   position: absolute;
    //   top: 40px;
    //   right: 40px;
    //   font-size: 40px;
    //   color: #ff0000;
    // }

    .paper_title {
      text-align: center;
    }

    .info_row {
      margin-top: 10px;
      padding-bottom: 20px;
      font-size: 16px;
      color: #666;
      text-align: center;
      border-bottom: dashed 1px #ddd;

      .submit_time {
        margin-left: 250px;
      }

      .score_table {
        margin-top: 20px;
        margin-left: auto;
        margin-right: auto;
      }
    }

    .type_title {
      float: left;
      padding-left: 30px;
      font-size: 20px;
    }

    .get_score {
      float: right;
      font-size: 20px;
    }

    .one {
      padding: 10px 0 20px 30px;
      font-size: 18px;
      border-bottom: solid 1px #ddd;

      .options {
        .option {
          margin: 10px 0;
        }
      }

      .my_answer {
        margin-bottom: 10px;
        color: #67c23a;
      }

      .anwser {
        color: #ff0000;
      }
    }
  }
}
</style>